// @flow
import { graphql, useStaticQuery } from 'gatsby';
import useCurrentLocale from '~plugins/i18n/hooks/useCurrentLocale';
import type { Query, PrismicEntryTag } from '~schema';

const query = graphql`
  query UseEntryTagQuery {
    allPrismicEntryTag {
      nodes {
        id
        uid
        lang
        data {
          name {
            text
            html
          }
          group_category {
            text
          }
        }
      }
    }
  }
`;

export default function useEntryTags(): ?Array<?PrismicEntryTag> {
  const locale = useCurrentLocale();
  const nodes = useStaticQuery<Query>(query).allPrismicEntryTag?.nodes;
  return nodes && locale
    ? nodes.filter(node => node.lang === locale.prismicLocale)
    : null;
}
